import React, {useMemo, useState} from "react";
import {CircularProgress, Fade} from "@mui/material";
import {Col} from "reactstrap";
import {ReactComponent as SaveIcon} from "../../../../assets/images/save-rollback/check.svg";
import {ReactComponent as CancelIcon} from "../../../../assets/images/save-rollback/cancel.svg";
import classnames from "classnames";

const SaveOrRollback = ({
                            onSave,
                            onRollback,
                            show,
                            column = true,
                            showText = true,
                            loading: loadingProp,
                        }) => {
    const [loading, setLoading] = useState(false);

    const propLoadingAvailable = useMemo(() => !!loadingProp, [loadingProp]);
    const showSave = useMemo(() =>
            (typeof show === 'object' && show.save === true) ||
            (typeof show !== 'object' && show),
        [show])
    const showCancel = useMemo(() =>
            (
                (typeof show === 'object' && show.cancel === true) ||
                (typeof show !== 'object' && show)
            ) && !(loading || loadingProp),
        [show, loading, loadingProp])

    return (
        <Fade in={!!show} mountOnEnter unmountOnExit>
            <div
                className={classnames('row no-gutters align-items-center justify-content-center m-2 save-rollback', {})}>
                <Col
                    className={classnames({
                        'mr-1': !showText,
                        'mr-2': (showSave || column) && showText,
                        'mr-4': !showSave && !column && showText,
                    })}
                >
                    <Fade in={!!showSave} mountOnEnter unmountOnExit>
                        <div
                            onClick={() => !!showSave && !loading && !loadingProp && (propLoadingAvailable ? onSave() : onSave(setLoading))}
                            className={classnames('icon-container save-container d-flex', {
                                "flex-column align-items-center justify-content-center": column,
                                "align-items-center justify-content-center": !column,
                            })}
                        >
                            {
                                loading || loadingProp
                                    ? <CircularProgress
                                        size={15}
                                        color={'secondary'}
                                        className={classnames({"mr-2": !column && showSave && showText})}
                                    />
                                    : <SaveIcon
                                        className={classnames(`save`, {"mr-2": !column && showSave && showText})}/>
                            }
                            <Fade in={showText} mountOnEnter unmountOnExit>
                                <p className={'save-label'}>
                                    {
                                        loading || loadingProp
                                            ? 'loading...'
                                            : 'Save'
                                    }
                                </p>
                            </Fade>
                        </div>
                    </Fade>
                </Col>
                <Col
                    className={classnames({
                        'mr-1': !showText,
                        'mr-2': (showSave || column) && showText,
                        // 'mr-4': !showSave && !column && showText,
                    })}
                >
                    <Fade in={!!showCancel} mountOnEnter unmountOnExit>
                        <div
                            onClick={() => !!showCancel && onRollback()}
                            className={classnames('icon-container d-flex', {
                                "flex-column align-items-center justify-content-center": column,
                                "align-items-center justify-content-center ": !column,
                            })}
                        >
                            {
                                loading || loadingProp
                                    ? <CircularProgress
                                        size={15}
                                        color={'secondary'}
                                        className={classnames({"mr-2": !column && showSave && showText})}
                                    />
                                    : <CancelIcon
                                        className={classnames(`cancel`, {"mr-2": !column && showCancel && showText})}/>
                            }
                            <Fade in={showText} mountOnEnter unmountOnExit>
                                <p className={'cancel-label'}>
                                    {
                                        loading || loadingProp
                                            ? 'loading...'
                                            : 'Cancel'
                                    }
                                </p>
                            </Fade>
                        </div>
                    </Fade>
                </Col>
            </div>
        </Fade>
    );
}

export default SaveOrRollback;
